import styled, { css } from 'styled-components';

export const ModalContent = styled.div(
  ({ theme }) => css`
    margin: ${theme.sz.s16} ${theme.sz.s8};
    display: flex;
    flex-direction: column;
    text-align: center;
  `,
);

export const Header = styled.div(
  ({ theme }) => css`
    ${theme.typography.heading.mobile.m};
  `,
);

export const UpgradeToProWrapper = styled.span(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.sz.s3};
    width: 100%;
  `,
);

export const Text = styled.div(
  ({ theme }) => css`
    ${theme.typography.paragraph.base};
  `,
);
